module.exports = __webpack_public_path__ + "public/files/img/banner.e1b2058e.png";